import { useEffect, useRef } from 'react';

export const usePrevious = <T extends object>(value: T): T | undefined => {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export const useDeepEffect = (fn: () => void, deps: React.DependencyList) => {
  const isFirst = useRef(true);
  const prevDeps = useRef(deps);

  useEffect(() => {
    const isFirstEffect = isFirst.current;

    const isSame = prevDeps.current.every((obj, index: number) => JSON.stringify(obj) === JSON.stringify(deps[index]));

    isFirst.current = false;
    prevDeps.current = deps;

    if (isFirstEffect || !isSame) {
      return fn();
    }
  }, deps); /* TODO: rules-of-hooks */ // eslint-disable-line react-hooks/exhaustive-deps
};
